module.exports = __webpack_public_path__ + "img/b4aa372.png";